import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TSubmitInvoicePaymentRequest } from "./submitInvoicePayment.schema";

export const submitInvoicePayment =
  (axios: IAxiosInstance) => async (body: TSubmitInvoicePaymentRequest) => {
    const response = await axios.noRetry.post<IApiResponse<boolean>>(
      "/api/invoices/payment",
      body
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
